<template>
  <breadcrumb :links="{ '/': 'Home', 'current': 'Mappa sensori' }"></breadcrumb>

  <div class="container-xl p-0 py-sm-2 px-sm-3">
    <div id="content_container">
      <div id="sidebar" v-if="showSidebar">
        <div class="sensor_links">
          <a v-for="(sensor, sensor_code) in sensors" v-bind:key="sensor_code"
            :class="'sensor_link' + (sensor_code == current ? ' active' : '')" v-on:click="loadMeasures(sensor_code)">
            {{ sensor.name }}
          </a>
        </div>
        <div class="map_legend">
          <Legend v-if="legend != undefined && legend.type != 'value'" :legend="this.legend">
          </Legend>
        </div>
      </div>
      <button class="btn btn-light button" id="close_sidebar" v-on:click="showSidebar = false; showXButton = false"
        v-if="showXButton">
        <i class="bi bi-x-lg p-2"></i>
        <span class="text-color">{{ sensors[current].name }}</span>
      </button>
      <div id="map_container">
        <button v-if="!showSidebar" id="show_sidebar" class="btn btn-light button"
          v-on:click="showSidebar = true; showXButton = true">
          <i class="bi bi-list p-2"></i>
          <span class="text-color">{{ sensors[current].name }}</span>
        </button>
        <Map class="map" :markers="mapMarkers" :currentSensor="current" :downloadButton="downloadButton">
          <template #popup="{ item }">
            <template v-if="item.get">
              <p class='text-primary fw-bold text-center'>{{ item.get('name') }}</p>
              <p class='text-center'>{{ sensors[current].name }} : <span class="text-primary">{{
                item.get('value').toFixed(1) }} </span>{{ ' ' + sensors[current].legend.units }}</p>
              <p class='text-center'>{{ convertTime(item.get('date')) }}</p>
              <a :href="item.get('link')" class="btn btn-primary btn-sm">Vai al sensore</a>
            </template>
          </template>
        </Map>

      </div>
    </div>
  </div>

  <app-footer-mini></app-footer-mini>
</template>

<script>
import Map from '@/components/Map/BaseFvgMap'
import Legend from '@/components/Legend'
import MonitorApi from '@/services/MonitorApi';
import ColorUtils from '@/utils/colors';
import Labels from '@/utils/labels';
import Breadcrumb from '@/components/Breadcrumb'
import AppFooterMini from '@/app-footer-mini.vue'
import { circleMarkerUI, imageMarkerUI, textMarkerUI } from '@/components/Map/MapMarkers';

export default {
  components: { Map, Legend, Breadcrumb, AppFooterMini },
  mixins: [Labels],
  data: function () {
    return {
      loader: false,
      showSidebar: true,
      showXButton: false,
      downloadButton: true,
      current: '',
      legend: {},
      mapMarkers: [],
      sensors: {
        temperature: {
          id: 2,
          name: 'Temperatura',
          legend: {
            units: "°C",
            type: 'ramp',
            range: [-10.0, 35.0],
            num_labels: 10,
            num_colors: 100,
            stops: [
              { color: { r: 0, b: 255, g: 0, a: 1.0 }, value: 0.0 },
              { color: { r: 0, b: 255, g: 255, a: 1.0 }, value: 0.25 },
              { color: { r: 0, b: 0, g: 255, a: 1.0 }, value: 0.5 },
              { color: { r: 255, b: 0, g: 255, a: 1.0 }, value: 0.75 },
              { color: { r: 255, b: 0, g: 0, a: 1.0 }, value: 1.0 }
            ]
          }
        },
        precipitations_1h: {
          id: 53,
          name: 'Piogge 1h',
          legend: {
            units: "mm/h",
            type: 'ramp',
            num_labels: 6,
            num_colors: 100,
            range: [0, 50.0],
            stops: [
              { color: { r: 255, b: 255, g: 255, a: 1.0 }, value: 0.0 },
              { color: { r: 200, b: 255, g: 200, a: 1.0 }, value: 0.10 },
              { color: { r: 0, b: 255, g: 0, a: 1.0 }, value: 1.0 }
            ]
          }
        },
        precipitations_24h: {
          id: 57,
          name: 'Piogge 24h',
          legend: {
            units: "mm/giorno",
            type: 'ramp',
            num_labels: 6,
            num_colors: 100,
            range: [0, 200.0],
            stops: [
              { color: { r: 255, b: 255, g: 255, a: 1.0 }, value: 0.0 },
              { color: { r: 200, b: 255, g: 200, a: 1.0 }, value: 0.10 },
              { color: { r: 0, b: 255, g: 0, a: 1.0 }, value: 1.0 }
            ]
          }
        },
        humidity: {
          id: 3,
          name: 'Umidità',
          legend: {
            units: "%",
            type: 'ramp',
            num_labels: 6,
            num_colors: 100,
            range: [0, 100.0],
            stops: [
              { color: { r: 255, b: 255, g: 255, a: 1.0 }, value: 0.0 },
              { color: { r: 0, b: 0, g: 255, a: 1.0 }, value: 0.5 },
              { color: { r: 0, b: 255, g: 255, a: 1.0 }, value: 1.0 }
            ]
          }
        },
        pressure: {
          id: 17,
          name: 'Pressione',
          legend: {
            units: "hPa",
            type: 'ramp',
            num_labels: 5,
            num_colors: 100,
            range: [950, 1050],
            stops: [
              { color: { r: 150, b: 150, g: 150, a: 1.0 }, value: 0.0 },
              { color: { r: 255, b: 100, g: 100, a: 1.0 }, value: 0.5 },
              { color: { r: 255, b: 0, g: 0, a: 1.0 }, value: 1.0 }
            ]
          }
        },
        wind: {
          intensity_ids: [6],
          direction_ids: [5],
          name: 'Vento',
          legend: {
            units: "m/s",
            type: 'markers',
            markers: [{
              label: 'calma',
              src: 'wind_0.png'
            }, {
              label: 'tra 0 e 5 m/s',
              src: 'wind_1.png'
            }, {
              label: 'tra 5 e 10 m/s',
              src: 'wind_2.png'
            }, {
              label: 'sopra i 10 m/s',
              src: 'wind_3.png'
            }]
          }
        },
        idro: {
          ids: [24, 25, 26],
          name: 'Idrometri',
          legend: {
            units: "m",
            decimals: 2,
            type: 'value'
          },
          show_label: true
        },
        portata: {
          ids: [27, 28, 29],
          name: 'Portata',
          legend: {
            units: "m/c",
            decimals: 1,
            type: 'value'
          },
          show_label: true
        }
      }
    }
  },
  methods: {
    toggleSidebar: function () {
      this.showSidebar = !this.showSidebar
    },
    loadMeasures: async function (sensor) {
      this.current = sensor;
      this.legend = this.sensors[sensor].legend;
      this.legend.title = this.sensors[sensor].name + ' ' + this.legend.units;
      let data = [];

      let sens = this.sensors[sensor];
      if (sens.id) {
        data = await MonitorApi.getLatestMeasures(sens.id);
        this.mapMarkers = data.map(d => ({
          date: d.dt,
          lat: d.lat,
          lon: d.lon,
          name: d.station_name,
          label: d.station_name,
          value: d.value,
          ui: this.pointStyle(d.value, null, sens.show_label),
          ui_label: sens.show_label ? d.value.toFixed(1).toString() + ' ' + sens.legend.units : null,
          link: `#/misure/${d.station_id}/${d.sensor_id}`
        }));
      }
      else if (sens.ids) {
        for (let i = 0; i < sens.ids.length; i++) {
          let d = await MonitorApi.getLatestMeasures(sens.ids[i]);
          data = data.concat(d);
        }
        this.mapMarkers = data.map(d => ({
          date: d.dt,
          lat: d.lat,
          lon: d.lon,
          name: d.station_name,
          label: d.station_name,
          value: d.value,
          ui: this.pointStyle(d.value, null, sens.show_label),
          ui_label: sens.show_label ? d.value.toFixed(1).toString() + ' ' + sens.legend.units : null,
          link: `#/misure/${d.station_id}/${d.sensor_id}`
        }));
      }
      else if (sens.intensity_ids && sens.direction_ids) {
        let vals = await MonitorApi.getLatestMeasures(sens.intensity_ids[0]);
        let rots = await MonitorApi.getLatestMeasures(sens.direction_ids[0]);

        this.mapMarkers = vals.map(d => {
          let r = rots.filter(x => x.station_id == d.station_id)[0] || {};
          return {
            date: d.dt,
            lat: d.lat,
            lon: d.lon,
            name: d.station_name,
            label: d.station_name,
            value: d.value,
            ui: this.pointStyle(d.value, r.value, sens.show_label),
            ui_label: sens.show_label ? d.value.toFixed(1).toString() + ' ' + sens.legend.units : null,
            link: `#/misure/${d.station_id}/${d.sensor_id}`
          };
        });
      }
    },
    pointStyle: function (value, value2, with_label) {
      let res = null;
      if (this.legend.type == 'ramp') {
        let p = (value - this.legend.range[0]) / (this.legend.range[1] - this.legend.range[0]);
        if (p < 0) p = 0.0;
        if (p > 0.99) p = 0.99;
        const color = ColorUtils.rgb2Hex(ColorUtils.gradient(this.legend.stops, p));
        res = circleMarkerUI({ stroke: '#AEAEAE', fill: color });
      }
      else if (this.legend.type == 'markers') {
        const wind_level =
          value > 10 ? 3 :
            value > 5 ? 2 :
              value > 0 ? 1 :
                0;
        let icon = '/map_icons/wind_' + wind_level + '.png';
        res = imageMarkerUI({ src: icon, rotation: value2 });
      }
      else if (this.legend.type == 'value') {
        res = circleMarkerUI({ stroke: '#AEAEAE', fill: 'rgba(0,0,100,0.7)' });
      }
      if (with_label == true) {
        res = [res, textMarkerUI({
          font: '14px Calibri,sans-serif',
          fill: '#000',
          stroke: '#fff',
          offsetY: -15
        })];
      }
      return res;
    },
    style: function () {
      if (this.current == 'precipitations') {
        return circleMarkerUI({ stroke: '#AEAEAE', fill: '#3333FF' });
      }
      else {
        return circleMarkerUI({ stroke: '#AEAEAE', fill: '#AAAAAA' });
      }
    }
  },
  mounted: function () {

    this.showSidebar = false;
    this.loadMeasures('temperature');
    const now = new Date();
    if (now > new Date(now.getFullYear(), 10, 15) || now < new Date(now.getFullYear(), 4, 31)) {
      this.sensors.nivo = {
        ids: [23],
        name: 'Nivometri',
        legend: {
          units: "cm",
          decimals: 1,
          type: 'value'
        },
        show_label: true
      };
    }
  }

}
</script>

<style lang="scss" scoped>
.button {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  width: 50px;
  height: auto;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.text-color {
  padding: 10px;
  writing-mode: vertical-rl;
  text-orientation: sideways-right;
  transform: rotate(180deg);
  color: #0067b1;
}

#content_container {
  position: relative;
  width: 100%;
  height: 100%;
}

#map_container {
  height: 100%;

  .map {
    height: 100%;
  }
}

#sidebar {
  z-index: 1010;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 200px;
  background-color: #fff;
  opacity: 0.8;
  overflow: auto;

  .sensor_links {
    overflow: hidden;

    .sensor_link {
      display: block;
      text-align: center;
      cursor: pointer;
      text-decoration: none;
      color: #0067b1;
      font-variant: small-caps;
      font-weight: bold;
      font-size: 1.2em;
      padding-right: 5px;

      &:hover {
        background-color: #ccc;
      }
    }

    .active {
      background-color: #0067b1;
      color: #fff;

      &:hover {
        color: #0067b1;
        background-color: #ccc;
      }
    }
  }
}

#close_sidebar {
  position: absolute;
  left: 200px;
  z-index: 999;
  background-color: #fff;
  opacity: 0.8;
  font-variant: small-caps;
  font-weight: bold;
}

#show_sidebar {
  position: absolute;
  top: 10px;
  left: 0;
  z-index: 2000;
  font-variant: small-caps;
  font-weight: bold;
}

.map_legend {
  padding-top: 10px;
  height: 370px;
  background-color: #fff;
}
</style>